import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Actions, Location, Partner} from '@app/shared';
import {getSafeImageUrl, ScreenService} from '@app/core';
import {GlobalValuesService} from '../../../core/services/global-values.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-info-card',
  standalone: false,

  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.less'
})
export class InfoCardComponent implements OnInit, OnDestroy {

  @Input() isActive: boolean = false;
  @Input() isAlert: boolean = false;
  @Input() name: string | undefined;
  @Input() icon: string | undefined;
  @Input() date: string | undefined;
  @Input() origin: Location | undefined;
  @Input() destination: Location | undefined;
  @Input() totalOrders: number | undefined;
  @Input() completedOrders: number | undefined;
  @Input() actions: Actions = {copy: true, file: true, message: true, drawer: false, select: false};
  @Input() checkboxConfig: { show: boolean; isChecked: boolean } = {show: false, isChecked: false};
  @Input() supplierId?: number; // @deprecated - Usar supplierIds o suppliers en su lugar
  @Input() supplierIds?: number[]; // Lista de IDs de suppliers
  @Input() suppliers?: Partner[]; // Lista de suppliers (preferido si está disponible)

  providers: Partner[] = [];

  @Output() actionEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() checkboxEvent: EventEmitter<void> = new EventEmitter<void>();

  isMobile$;
  partnerSubscribe: Subscription | undefined;
  protected readonly getSafeImageUrl = getSafeImageUrl;

  constructor(private screenService: ScreenService, public gs: GlobalValuesService) {
    this.isMobile$ = this.screenService.isMobile$;
  }

  // Calcula el porcentaje de órdenes completadas
  get percent(): number {
    return (this.totalOrders && this.completedOrders) ? (this.completedOrders / this.totalOrders) * 100 : 0;
  }

  // Opcional: Método o getter para determinar el status
  get progressStatus(): 'exception' | 'normal' | 'success' {
    const p = this.percent;
    return p <= 15 ? 'exception' : (p <= 60 ? 'normal' : 'success');
  }

  ngOnInit() {
    this.partnerSubscribe = this.gs.isPartnerReady$.subscribe(value => {
      if (value) {
        this.loadProviders();
      }
    })
  }

  private loadProviders() {
    const providers: Partner[] = [];

    // Si tenemos la lista de suppliers directamente, usarla
    if (this.suppliers && this.suppliers.length > 0) {
      providers.push(...this.suppliers);
    }
    // Si tenemos supplierIds, buscar los partners
    else if (this.supplierIds && this.supplierIds.length > 0) {
      this.supplierIds.forEach(id => {
        const partner = this.gs.providerList.find(p => p.id === id);
        if (partner) {
          providers.push(partner);
        }
      });
    }
    // Compatibilidad: si solo tenemos supplierId único
    else if (this.supplierId) {
      const partner = this.gs.providerList.find(p => p.id === this.supplierId);
      if (partner) {
        providers.push(partner);
      }
    }

    this.providers = providers;
  }

  ngOnDestroy() {
    this.partnerSubscribe?.unsubscribe();
  }

  onAction(action: string): void {
    this.actionEvent.emit(action);
  }

  checkboxChange(): void {
    this.checkboxEvent.emit();
  }
}
